import { FC } from 'react'
import PerFlexRow from '../FlexRow/index'
import PerText from '../Text'
import { Checkbox } from 'antd'
import { MeetingStepViewId } from '../../../types'
import { useTranslation } from 'react-i18next'

interface Props {
  viewIds: MeetingStepViewId[]
  onCheckStep: (viewId: MeetingStepViewId, checked: boolean) => void
}

export const AppraisalInviteSteps: FC<Props> = ({ viewIds, onCheckStep }) => {
  const [t] = useTranslation()
  const containsStepViewId = (stepId: MeetingStepViewId): boolean => {
    if (viewIds) {
      return !!viewIds.find((x) => x === stepId)
    }
    return false
  }

  return (
    <div data-testid="invite-modal-appraisal-steps">
      <PerFlexRow direction="column">
        <PerText>
          <Checkbox
            name="checkSelfReflection"
            checked={containsStepViewId(MeetingStepViewId.SelfReflection)}
            onChange={(e) => {
              onCheckStep(MeetingStepViewId.SelfReflection, e.target.value)
            }}
          >
            {t('meetingInvite.steps.selfReflection')}
          </Checkbox>
        </PerText>
        <PerText mt="s">
          <Checkbox
            name="checkEvaluation"
            checked={containsStepViewId(MeetingStepViewId.Evaluation)}
            onChange={(e) => {
              onCheckStep(MeetingStepViewId.Evaluation, e.target.value)
            }}
          >
            {t('meetingInvite.steps.evaluation')}
          </Checkbox>
        </PerText>
        <PerText mt="s">
          <Checkbox
            name="checkPastTargets"
            checked={containsStepViewId(MeetingStepViewId.PastTargets)}
            onChange={(e) => {
              onCheckStep(MeetingStepViewId.PastTargets, e.target.value)
            }}
            disabled
          >
            {t('meetingInvite.steps.pastTargets')}
          </Checkbox>
        </PerText>
        <PerText mt="m">
          <Checkbox
            name="checkContractChanges"
            checked={containsStepViewId(MeetingStepViewId.ContractChanges)}
            onChange={(e) => {
              onCheckStep(MeetingStepViewId.ContractChanges, e.target.value)
            }}
            disabled
          >
            {t('meetingInvite.steps.contractChanges')}
          </Checkbox>
          <PerText mt="s">
            <Checkbox
              name="checkNewTargets"
              checked={containsStepViewId(MeetingStepViewId.NewTargets)}
              onChange={(e) => {
                onCheckStep(MeetingStepViewId.NewTargets, e.target.value)
              }}
              disabled
            >
              {t('meetingInvite.steps.newTargets')}
            </Checkbox>
          </PerText>
        </PerText>
      </PerFlexRow>
    </div>
  )
}
